// ----------------------------------------------------
// -----Komponenten zum Vereinfachen des Codes --------

import { Autocomplete, TextField } from "@mui/material";

// ----------------------------------------------------
export function FormTextField({ indexKey, required = false, label, formValues, handleChange, disabled }) {
  return (
    <TextField
      key={indexKey}
      variant="outlined"
      label={label}
      value={formValues[indexKey] ?? ""}
      onChange={(event) => handleChange(event, indexKey)}
      id={indexKey}
      name={indexKey}
      fullWidth
      disabled={disabled}
      required={required}
      margin="normal"
      size="small"
      InputLabelProps={{
        shrink: true,
      }}
    />
  );
}

export function FormNumField({ indexKey, label, formValues, setFormValues, disabled }) {
  return (
    <TextField
      label={label}
      value={formValues[indexKey] ? formValues[indexKey] : ""}
      placeholder="0000.0"
      size="small"
      fullWidth
      disabled={disabled}
      margin="normal"
      onChange={(event) => {
        setFormValues({ ...formValues, [indexKey]: event.target.value });
      }}
      onBlur={() => {
        const tmpValue = formValues[indexKey];
        if (tmpValue === "") return;
        if (tmpValue === undefined) return;
        if (tmpValue === null) return;

        const num = Number(tmpValue.replace(",", "."));

        if (!Number.isNaN(num)) {
          setFormValues({ ...formValues, [indexKey]: num.toFixed(1) });
        }
      }}
    />
  );
}

export function FormAutoComplete({ indexKey, options, label, required, formValues, disabled, setFormValues, dialogVersion }) {
  if (!options) {
    return null;
  }

  const changeAutoComplete = (newValue) => {
    const newFormValues = { ...formValues, [indexKey]: newValue?.value ? newValue.value : null };
    if (indexKey === "startKategorie") {
      newFormValues["startFhw"] = null;
    }

    if (dialogVersion == 2) {
      switch (indexKey) {
        case "startStandort":
          if (!newFormValues["zielStandort"]) {
            newFormValues["zielStandort"] = newValue?.value ? newValue.value : null;
          }
          break;

        case "startRaum":
          if (!newFormValues["zielRaum"]) {
            newFormValues["zielRaum"] = newValue?.value ? newValue.value : null;
          }
          break;

        case "startStecker":
          if (!newFormValues["zielStecker"]) {
            newFormValues["zielStecker"] = newValue?.value ? newValue.value : null;
          }
          break;

        default:
          break;
      }
    }

    setFormValues(newFormValues);
  };

  return (
    <Autocomplete
      value={formValues[indexKey] ? options.find((option) => option.value === formValues[indexKey]) : null}
      id={indexKey}
      options={options}
      disabled={disabled}
      getOptionLabel={(option) => `${option.label} (${option.value})`}
      onChange={(event, newValue) => {
        changeAutoComplete(newValue);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          variant="outlined"
          required={required}
          id={indexKey}
          size="small"
          margin="normal"
          fullWidth
          InputLabelProps={{
            shrink: true,
          }}
        />
      )}
      // isOptionEqualToValue={(option, value) => option.value === value}
    />
  );
}
